<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-7 col-md-7 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          Inspection Conditions &nbsp;
          <add-button
            link="/planned-maintenance/inspection-conditions/create"
          ></add-button>
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-5 col-sm-6 col-md-5 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Planned Maintenance</li>
          <li class="breadcrumb-item">Inspection Conditions</li>
          <li class="breadcrumb-item active" aria-current="page">List</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Search & Filtering  -->
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
            <input
              type="text"
              class="form-control"
              placeholder="Search..."
              v-model="searchData"
              @keydown.enter="search"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- Search & Filtering  -->
    <!-- Table -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- Export To Excel -->
            <div class="row">
              <div class="col-md-8"></div>
              <div class="col-md-4">
                <div style="float: right">
                  <a
                    href="#"
                    class="btn btn-primary"
                    v-if="Exportinspection_conditions.length == 0"
                    @click="exportToExcel"
                  >
                    <span v-if="isExcelloading">
                      <div class="d-flex align-items-center">
                        <strong>Generating Excel</strong>
                        &nbsp;
                        <div
                          class="
                            spinner-border
                            text-light
                            spinner-border-sm
                            ms-auto
                          "
                          role="status"
                          aria-hidden="true"
                        ></div>
                      </div>
                    </span>
                    <span v-else>Generate Excel</span>
                  </a>
                  <download-excel
                    :title="title"
                    v-else
                    class="btn btn-success"
                    :data="inspection_conditions_excel"
                    :fields="excel_fields"
                    worksheet="Inspection Conditions"
                    name="Inspection Condition.xls"
                    >Download Excel
                  </download-excel>
                </div>
              </div>
            </div>
            <br />
            <!-- End Export to Excel -->
            <div class="table-responsive">
              <table id="dataTableExample" class="table table-hover">
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>Condition</th>
                    <th>Level</th>
                    <th>Created Date</th>
                    <th>Created By</th>
                    <th>Edited Date</th>
                    <th>Edited By</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Table Loader -->
                  <loading-table
                    :isLoading="isLoading"
                    cols="8
                        "
                  ></loading-table>
                  <!-- If No Data Received-->
                  <tr v-if="inspection_conditions.length == 0">
                    <td colspan="8" class="text-center" style="color: grey">
                      No Data Found
                    </td>
                  </tr>
                  <!-- If data Received -->
                  <tr
                    v-for="(inspection_condition, at) in inspection_conditions"
                    :key="`inspection_condition${at}`"
                  >
                    <td>{{ serialNoStarting + at + 1 }}</td>
                    <td>{{ inspection_condition.condition }}</td>
                    <td>{{ inspection_condition.level }}</td>
                    <td>{{ inspection_condition.created_at | ddmmyyyy }}</td>
                    <td>{{ inspection_condition.created_by.name }}</td>
                    <td>{{ inspection_condition.updated_at | ddmmyyyy }}</td>
                    <td>{{ inspection_condition.edited_by.name }}</td>
                    <td>
                      <div>
                        <router-link
                          :to="`/planned-maintenance/inspection-conditions/${inspection_condition.id}`"
                          tag="button"
                          class="btn btn-primary btn-sm"
                          >Edit</router-link
                        >
                        &nbsp; &nbsp;
                        <button
                          class="btn btn-danger btn-sm"
                          @click="delete_data(inspection_condition.id)"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /Table -->
            </div>
            <pagination :count="count" @submit="getData"></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";
import moment from "moment";

export default {
  name: "approvallimit",
  data() {
    return {
      inspection_conditions: [],
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
      isExcelloading: false,
      searchData: "",
      inspection_conditions_excel: [],
      excel_fields: {
        "Sr No": "sr_no",
        Condition: "condition",
        Level: "level",
        "Created Date": "created_date",
        "Created By": "created_by",
        "Edited Date": "edited_date",
        "Edited By": "edited_by",
      },
      Exportinspection_conditions: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // async getData() {
    async getData(page = 1) {
      this.isLoading = true;
      let inspection_conditions = await axios.get(
        `/inspection_conditions?page=${page}&rowsPerPage=${this.rowsPerPage}`
      );
      this.inspection_conditions = inspection_conditions.data.data;
      this.count = inspection_conditions.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.isLoading = false;
    },
    async search() {
      this.isLoading = true;
      let inspection_conditions = await axios.get(
        `/inspection_conditions?search=${this.searchData}`
      );
      this.inspection_conditions = inspection_conditions.data.data;
      this.count = inspection_conditions.data.count;
      this.isLoading = false;
    },
    async exportToExcel() {
      this.isExcelloading = true;
      this.title = "Inspection Condition Data";
      this.inspection_conditions_excel = [];
      let Exportinspection_conditions = [];
      Exportinspection_conditions = await axios.get(`/inspection_conditions`);
      this.Exportinspection_conditions = Exportinspection_conditions.data.data;
      let sr_no = 1;
      this.Exportinspection_conditions.forEach((inspection_condition) => {
        this.inspection_conditions_excel.push({
          sr_no: sr_no,
          condition: inspection_condition.condition
            ? inspection_condition.condition
            : "",
          level: inspection_condition.level ? inspection_condition.level : "",
          created_date: inspection_condition.created_at
            ? moment(inspection_condition.created_at).format("DD-MM-YYYY")
            : "",
          created_by: inspection_condition.created_by
            ? inspection_condition.created_by.name
            : "",
          edited_date: inspection_condition.updated_at
            ? moment(inspection_condition.updated_at).format("DD-MM-YYYY")
            : "",
          edited_by: inspection_condition.edited_by
            ? inspection_condition.edited_by.name
            : "",
        });
        sr_no++;
      });
      this.isExcelloading = false;
    },
    async delete_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=inspection_conditions`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
